export default function isSkipFcntChecker(arr) {
  const skipCache = {}
  return arr
    .reverse()
    .map((item) => {
      if (item.direction !== "RX") return item
      if (!skipCache[item.devEUI]) {
        skipCache[item.devEUI] = item.FCntUp
        return item
      }
      const skipped = item.FCntUp - skipCache[item.devEUI] === 1 ? false : true
      skipCache[item.devEUI] = item.FCntUp
      return { ...item, skipped }
    })
    .reverse()
}
